import { Component, OnInit } from '@angular/core';

import { TableData } from '../../../lbd/lbd-table/lbd-table.component';
import { LegendItem, ChartType } from '../../../lbd/lbd-chart/lbd-chart.component';
import { Task } from '../../../lbd/lbd-task-list/lbd-task-list.component';
import { Router, Route } from '@angular/router';
import * as Chartist from 'chartist';
import Swal from 'sweetalert2';
import { ValuacionService } from '../valuacion-moneda-extranjera/valuacion.service';
import { LoginService } from '../../login/login.service';

import { DashboardService } from '../../../dashboard/dashboard.service';
@Component({
  selector: 'app-valuar-mon-ext',
  templateUrl: './valuar-mon-ext.component.html',
  styleUrls: ['./valuar-mon-ext.component.css'],
  providers: [DashboardService],
  preserveWhitespaces: true
})
export class ValuarMonExtComponent implements OnInit {

  public tipoCambio: any[] = [];

  public dateCambio: any[] = [];
  public tcRecienteFecha: String = '';
  public tcChartType: ChartType;
  public tcChartData: any = {};
  public tcChartOptions: any;
  public tcChartResponsive: any[];
  public tcChartLegendItems: LegendItem[];

  public ejercicios: any[] = [{ periodos: [{}] }];
  public periodo: number;
  public ejercicio: number;
  public periodos: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public cargadoTc: boolean;

  constructor(public service: ValuacionService, public loginService: LoginService,
    private router: Router, private dashboardService: DashboardService) { }

  ngOnInit(): void {
    const hoy = new Date();
    this.periodo =  (hoy.getMonth() + 1);
    this.ejercicio =  hoy.getFullYear();
    this.ejercicios = JSON.parse(localStorage.getItem('ejercicios'));
    this.cargadoTc = false;
    this.dashboard();
  }
  dashboard() {
    this.dashboardService.getTc('USD', this.loginService.empresa).subscribe(
      response => {
        for (let x = 0; x < response.contenido.length; x++) {
          this.tipoCambio.unshift(response.contenido[x].valor);
        }
        for (let x = 0; x < response.contenido.length; x++) {
          this.dateCambio.unshift(response.contenido[x].fecha);
        }
        this.tcRecienteFecha = this.dateCambio[this.dateCambio.length - 1] === this.obtenerDia(0) ? 'HOY' : this.dateCambio[this.dateCambio.length - 1] === this.obtenerDia(1) ? 'AYER' : 'HACE MÁS DE DOS DÍAS';
        this.cargadoTc = true;
        this.crearDashboard();
      }, err => {
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      }
    );
  }

  mensajeSweetAlert(titulo: String, mensaje: String) {
    mensaje = mensaje.replace(',', '<br>');
      mensaje = mensaje.replace(':', ':<br>');
    Swal.fire({
      title: titulo + '',
      icon: 'info',
      html:
        mensaje + '',
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText:
        '<i class="fa fa-thumbs-up"></i> Entendido',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonAriaLabel: 'Thumbs down'
    })
  }
    crearDashboard() {
      this.tcChartType = ChartType.Line;
      this.tcChartData = {
        labels: [this.obtenerDia(5), this.obtenerDia(4)
          , this.obtenerDia(3), this.obtenerDia(2), this.obtenerDia(1), this.obtenerDia(0)]
      };
      this.tcChartData.labels = this.dateCambio;
      this.tcChartData.series = [this.tipoCambio];
      this.tcChartOptions = {
        low: 0,
        showArea: false,
        height: '300px',
        axisX: {
          showGrid: true,
        },
        axisY: {
          position: 'end',
          showGrid: true
        },
        lineSmooth: Chartist.Interpolation.simple({
          divisor: 10
        }),
        showLine: true,
        showPoint: true,
      };
      this.tcChartResponsive = [
        // Options override for media > 400px
        ['screen and (min-width: 400px)', {
          reverseData: true,
          horizontalBars: true,
          axisX: {
            labelInterpolationFnc: Chartist.noop
          },
          axisY: {
            offset: 60
          }
        }],
        // Options override for media > 800px
        ['screen and (min-width: 800px)', {
          stackBars: false,
          seriesBarDistance: 10,
          axisY: {
            labelInterpolationFnc: function(value) {
              const options2 = {};
              const numberFormat2 = new Intl.NumberFormat('es-MX', options2);
              return (numberFormat2.format(value) + '$');
            }
          }
        }],
        // Options override for media > 1000px
        ['screen and (min-width: 1000px)', {
          reverseData: false,
          horizontalBars: false,
          seriesBarDistance: 15, axisY: {
            labelInterpolationFnc: function(value) {
              const options2 = {};
              const numberFormat2 = new Intl.NumberFormat('es-MX', options2);
              return (numberFormat2.format(value) + '$');
            }
          }
        },
        ]
      ];
    }
    obtenerDia(hace: number) {
      const date = new Date();
      date.setDate(date.getDate() - hace);
      return (date.getDate() < 10 ? '0' : '') + date.getDate() + '/' +
        ((date.getMonth() + 1) < 10 ? '0' : '') + (date.getMonth() + 1);
    }
  ejecutarValuacion() {
    this.service.ejecutarValuacion(this.loginService.empresa as number, this.loginService.sucursal as number,
      this.periodo, this.ejercicio).subscribe(
        response => {
          Swal.fire('TNK Ledger', response.mensaje, 'success');
        }, err => {
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
        }
      );
  }
}
